var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ml-4"},[_c('div',[_c('a',{attrs:{"href":_vm.datadogLink,"target":"_blank"}},[_vm._v("\n            datadog logs\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }